/**
 * Una linea del carro.
 *
 * La foto y el nombre llevan a la ficha con un `<a>` real, como en la tarjeta
 * del listado: desde el carro se vuelve a mirar el producto mas seguido de lo
 * que parece.
 *
 * Un producto que quedo sin stock no se saca solo de la lista: se marca y se
 * deja que el comprador decida. Sacarselo sin avisar es como se pierde una
 * venta que se podia resolver por WhatsApp.
 */
import { Link } from 'react-router-dom';

import type { ItemCarro } from '@bandu/compartido';

import { pesos } from '../../utilidades/formato';
import { nombreConVariante } from '../../utilidades/producto';
import { rutas } from '../../utilidades/rutas';
import { Icono } from '../comunes/Icono';
import { FotoProducto } from '../comunes/Imagen';
import { SelectorCantidad } from './SelectorCantidad';

export interface LineaCarroProps {
  item: ItemCarro;
  alCambiarCantidad(cantidad: number): void;
  alQuitar(): void;
}

export function LineaCarro({ item, alCambiarCantidad, alQuitar }: LineaCarroProps) {
  const { producto, cantidad } = item;
  const enlace = rutas.producto(producto.slug);
  const agotado = producto.estadoStock === 'agotado';

  return (
    <li className={agotado ? 'carro-linea agotado' : 'carro-linea'}>
      <Link className="carro-foto" to={enlace} tabIndex={-1} aria-hidden="true">
        <FotoProducto imagen={producto.imagen} nombre={producto.nombre} />
      </Link>

      <div className="carro-datos">
        {producto.marca !== null ? <p className="carro-marca">{producto.marca}</p> : null}
        <h3>
          <Link to={enlace}>{producto.nombre}</Link>
        </h3>
        {producto.etiquetaVariante !== null ? (
          <p className="carro-variante">{producto.etiquetaVariante}</p>
        ) : null}
        <p className="carro-sku mono">{producto.sku}</p>
        {agotado ? (
          <p>
            <span className="etq etq-critico">
              <span className="punto" />
              Sin stock
            </span>
          </p>
        ) : null}
      </div>

      <div className="carro-cantidad">
        <SelectorCantidad
          cantidad={cantidad}
          nombre={producto.nombre}
          alCambiar={alCambiarCantidad}
        />
        <button
          type="button"
          className="btn btn-xs btn-suave carro-quitar"
          onClick={alQuitar}
          aria-label={`Quitar ${nombreConVariante(producto)} del carro`}
        >
          <Icono nombre="cerrar" />
          Quitar
        </button>
      </div>

      <p className="carro-monto">
        <span className="carro-total-linea">{pesos(producto.precio * cantidad)}</span>
        {cantidad > 1 ? (
          <span className="carro-unitario">{pesos(producto.precio)} c/u</span>
        ) : null}
      </p>
    </li>
  );
}
